import { Component, OnInit, OnDestroy } from '@angular/core';
import { VersionCheckService } from 'src/app/core/services/version-check.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
// import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-version-check',
  template: ``,
})
export class VersionCheckComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  private readonly NOTIFIED_VERSION_KEY = 'app_notified_version';

  constructor(
    private versionCheckService: VersionCheckService,
    // private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    // Start checking for new versions
    this.versionCheckService.startVersionCheck();

    // Subscribe to version availability
    const versionSub = this.versionCheckService
      .getIsNewVersionAvailable()
      .subscribe((isAvailable) => {
        if (isAvailable) {
          this.checkAndShowUpdateMessage();
        }
      });

    this.subscriptions.add(versionSub);
  }

  /**
   * Check if we've already notified the user about this version
   */
  private checkAndShowUpdateMessage(): void {
    // Get current deployed version (take first emission to avoid multiple checks)
    this.versionCheckService
      .getCurrentVersion()
      .pipe(take(1))
      .subscribe((currentVersion) => {
        if (!currentVersion) {
          return;
        }

        // Check if we've already notified about this version
        const notifiedVersion = localStorage.getItem(this.NOTIFIED_VERSION_KEY);

        if (notifiedVersion !== currentVersion) {
          // We haven't notified about this version yet
          // this.showUpdateMessage();
          // Mark that we've notified about this version
          localStorage.setItem(this.NOTIFIED_VERSION_KEY, currentVersion);
        }
      });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    // Stop version checking when component is destroyed
    this.versionCheckService.stopVersionCheck();
  }

  /**
   * Show update message to user
   */
  // private showUpdateMessage(): void {
  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Update Available',
  //     detail: 'A new version is available. Click here to refresh and get the latest updates.',
  //     sticky: true,
  //     closable: true,
  //     life: 0, // Don't auto-close
  //     data: {
  //       action: 'refresh',
  //     },
  //   });
  // }
}
